import { useState, useEffect } from 'react'
import { apiGet } from '@/lib/api'

const cache: Record<string, string[]> = {}

export function useRefList(key: string, fallback: string[] = []): string[] {
  const [items, setItems] = useState<string[]>(cache[key] ?? fallback)

  useEffect(() => {
    if (cache[key]) { setItems(cache[key]); return }
    apiGet(`/settings/fields/${key}`)
      .then((d: any) => {
        const vals: any[] = Array.isArray(d) ? d : (d?.values ?? d?.items ?? [])
        if (vals.length > 0) {
          const strings = vals
            .filter((v: any) => v?.is_active !== false)
            .map((v: any) => typeof v === 'string' ? v : v.label ?? v.value ?? String(v))
          if (strings.length > 0) {
            cache[key] = strings
            setItems(strings)
          }
        }
      })
      .catch(() => {}) // silently fall back to defaults
  }, [key])

  return items
}
